import { BaseDataLayer, DataLayerPlanType, PLAN_CODE_MAP, SALE_WITH_AGENT_MAP } from './base';

type FamilyActionType = 'Agregar' | 'Eliminar';

const baseEventParams = {
  product: 'Seguro Deceso',
  view_type: 'web',
  page_title: 'Deceso - Datos de familiares',
};

const pageViewDataLayer = (plan: DataLayerPlanType, insured: string, withAgent: boolean) => ({
  ...baseEventParams,
  page: '/deceso/datos-de-familiares',
  action_type: 'Pageview',
  product_type: plan,
  asegurados: insured,
  venta_asistida: SALE_WITH_AGENT_MAP[withAgent.toString()],
});

const familyClickDataLayer = (
  plan: DataLayerPlanType,
  insured: string,
  action: FamilyActionType
) => ({
  ...baseEventParams,
  page: '/deceso/datos-de-familiares',
  action_type: 'click',
  action: `Click - ${action} Familiar`,
  product_type: plan,
  asegurados: insured,
});

const infoClickDataLayer = (plan: DataLayerPlanType, insured: string) => ({
  ...baseEventParams,
  page: '/deceso/datos-de-familiares',
  action_type: 'click',
  action: 'Click - ¿A quienes puedo agregar como familiares?',
  product_type: plan,
  asegurados: insured,
});

const goBackClickDataLayer = (plan: DataLayerPlanType, insured: string) => ({
  ...baseEventParams,
  page: '/deceso/datos-de-familiares',
  action_type: 'click',
  action: 'Click - Volver',
  product_type: plan,
  asegurados: insured,
});

export const familyPageView = (planCode: string, insured: number, withAgent: boolean) =>
  BaseDataLayer({
    eventParams: pageViewDataLayer(PLAN_CODE_MAP[planCode], insured.toString(), withAgent),
  });

export const familyClick = (planCode: string, insured: number, action: FamilyActionType) =>
  BaseDataLayer({
    eventParams: familyClickDataLayer(PLAN_CODE_MAP[planCode], insured.toString(), action),
  });

export const familyInfoClick = (planCode: string, insured: number) =>
  BaseDataLayer({
    eventParams: infoClickDataLayer(PLAN_CODE_MAP[planCode], insured.toString()),
  });

export const familyGoBackClick = (planCode: string, insured: number) =>
  BaseDataLayer({
    eventParams: goBackClickDataLayer(PLAN_CODE_MAP[planCode], insured.toString()),
  });
